// src/stores/settings/banned-ip.store.js
import { defineStore } from "pinia";
import { ref } from "vue";
import BannedIpService from "@/services/settings/banned-ip.service";
import { toast } from "@/utils/toast";

export const useBannedIpStore = defineStore("bannedIps", () => {
  const rows = ref([]);
  const loading = ref(false);

  // currently selected IP for edit/delete
  const current = ref(null);

  function setCurrent(item = null) {
    current.value = item ? { ...item } : null;
  }

  async function fetchList() {
    loading.value = true;
    try {
      const res = await BannedIpService.getAll();
      rows.value = res.data || [];
    } catch (e) {
      toast(e?.response?.data?.message || "Failed to load banned IPs", "error");
    } finally {
      loading.value = false;
    }
  }

  async function create(payload) {
    loading.value = true;
    try {
      await BannedIpService.create(payload);
      toast("IP address banned successfully", "success");
      await fetchList();
    } catch (e) {
      toast(e?.response?.data?.message || "Failed to ban IP", "error");
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function update(id, payload) {
    loading.value = true;
    try {
      await BannedIpService.update(id, payload);
      toast("Banned IP updated", "success");
      await fetchList();
    } catch (e) {
      toast(e?.response?.data?.message || "Failed to update banned IP", "error");
      throw e;
    } finally {
      loading.value = false;
    }
  }

  async function remove(id) {
    loading.value = true;
    try {
      await BannedIpService.delete(id);
      toast("Banned IP removed", "success");
      await fetchList();
    } catch (e) {
      toast(e?.response?.data?.message || "Failed to remove banned IP", "error");
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return { rows, loading, current, setCurrent, fetchList, create, update, remove };
});
